<template>
    <div>
        <new-experimental-plan-component @submitNewExperimentalPlan="handleSubmitNewExperimentalPlan" :activeMethods="activeMethods" :activeValidationPlanTemplates="activeValidationPlanTemplates"></new-experimental-plan-component>
    </div>
</template>

<script>
import NewExperimentalPlanComponent from '@/components/plan/NewExperimentalPlanComponent'
import axios from "axios"
import { mapGetters, mapMutations } from 'vuex'
import MetadataParser from "@/valchrom/MetadataParser";
var moment = require('moment');

export default {
    name: "NewExperimentalPlan",
    components: {NewExperimentalPlanComponent},
    data: function () {
        return {
            component_url: 'experiments/plans',
            activeMethods: [],
            activeValidationPlanTemplates: [],
        }
    },
    computed: {
        ...mapGetters ([
            'base_url', 'auth_header'
        ])
    },
    mounted: function(){
        this.setBreadcrumb()
        this.getActiveValidationPlanTemplates()
        this.getActiveMethods()
    },

    methods: {
        ...mapMutations([
            'SET_BREADCRUMB'
        ]),
        setBreadcrumb: function(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        getActiveValidationPlanTemplates: function() {
            axios
                .get(`${this.base_url}experiments/templates?archived=False&exclude='IN PROGRESS'`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.activeValidationPlanTemplates = response.data;
                    this.activeValidationPlanTemplates.forEach(
                        (template)=>{
                          MetadataParser.getMetadatasFromJsons(template)
                        }
                    )
                    let sorter = (t1,t2)=>{
                      let compare = moment(t1.created_at) - moment(t2.created_at);
                      console.log(compare);
                      return -compare
                    }
                    this.activeValidationPlanTemplates.sort(sorter);
                    console.log("Active ValidationPlanTemplate in exPlanjson: ")
                    console.log(this.activeValidationPlanTemplates)
                })
                .catch(error => {
                    console.log("Something went wrong getting the ValidationPlanTemplates :(", error);
                });
        },
        getActiveMethods: function() {
            axios
                .get(`${this.base_url}experiments/methods?archived=False&status=COMPLETED,LOCKED`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.activeMethods = response.data;
                    console.log("Active method in explan json: ")
                    console.log(this.activeMethods)
                    let sorter = (t1,t2)=>{
                        let compare = moment(t1.created_at) - moment(t2.created_at);
                        console.log(compare);
                        return -compare
                    }
                    this.activeMethods.sort(sorter);
                })
                .catch(error => {
                    console.log("Something went wrong getting the methods :(", error);
                });
        },
        handleSubmitNewExperimentalPlan: function(newExperimentalPlan) {
            axios
                .post(
                    this.base_url + this.component_url,
                    newExperimentalPlan,
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Experimental Plan Successfully Created");
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan Successfully Created`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.$router.push({ name: "ExperimentalPlans", params: {  } });
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Experimental Plan was not successfully Created`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log(error.response.data) // display more meaningful error message
                });
        }
    }
}
</script>
